import { SET_USER_EMAIL } from "./UAM";
import { SET_USER_ID } from "./UAM";

export const initialUAMInfo = {
  email: null,
  userId: null,
};
const uamReducer = (state = {}, action) => {
  switch (action.type) {
    case SET_USER_EMAIL:
      return {
        ...state,
        email: action.email,
      };
    case SET_USER_ID:
      return {
        ...state,
        userId: action.userId,
      };
    default:
      // console.log("UAM DEFAULT")
      return initialUAMInfo;
  }
};

export default uamReducer;
